import { render, staticRenderFns } from "./ChatBoxTranslateFlex.vue?vue&type=template&id=103c88f4&scoped=true&"
import script from "./ChatBoxTranslateFlex.vue?vue&type=script&lang=js&"
export * from "./ChatBoxTranslateFlex.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxTranslateFlex.vue?vue&type=style&index=0&id=103c88f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103c88f4",
  null
  
)

export default component.exports